export default __webpack_public_path__ + "static/media/scrollRight3.4edbc4d6.jpg";